export enum Status {

  ACTIVE = "ACTIVE",
  LEAVE = "LEAVE",
  INACTIVE = "INACTIVE"

}
